import { render, staticRenderFns } from "./exportDialog2.vue?vue&type=template&id=0b8d65de&"
import script from "./exportDialog2.vue?vue&type=script&lang=js&"
export * from "./exportDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports